import { EmptyState, Icon } from '@chakra-ui/react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';

interface EmptyScreenProps {
  // Present when a viewer selected a specific date that has no plan
  // scheduled (viewers can't reach the choice screen to create one) —
  // swaps in the date-specific copy instead of the generic no-selection copy.
  date?: string;
}

// No date selected yet (or a viewer landed on an unscheduled date) — the
// calendar strip is waiting for a click, or there's simply nothing to show.
export default function EmptyScreen({ date }: EmptyScreenProps) {
  return (
    <EmptyState.Root>
      <EmptyState.Content>
        <EmptyState.Indicator>
          <Icon as={CalendarDaysIcon} w={8} h={8} />
        </EmptyState.Indicator>
        <EmptyState.Description>
          {date
            ? 'No plan is scheduled for this date.'
            : 'Select a date to schedule a practice or view a plan.'}
        </EmptyState.Description>
      </EmptyState.Content>
    </EmptyState.Root>
  );
}
